module.exports = __webpack_public_path__ + "static/media/madhacks.50def2d5.png";